let config = null
let loaded = false

function trimUrl (value) {
  return typeof value === 'string' ? value.trim() : ''
}

function resolveTier (tier, envFallback) {
  const fallback = trimUrl(envFallback)
  if (!tier || typeof tier !== 'object') return fallback

  const active = tier.active
  if (active !== 'old' && active !== 'new') return fallback

  const resolved = trimUrl(tier[active])
  return resolved || fallback
}

function getRuntimeConfigUrl () {
  const base = process.env.BASE_URL || '/'
  return `${base}runtime.config.json`
}

export async function loadRuntimeConfig () {
  if (loaded) return config

  const configUrl = getRuntimeConfigUrl()

  try {
    const response = await fetch(configUrl, { cache: 'no-store' })
    if (response.ok) {
      config = await response.json()
    } else if (process.env.NODE_ENV === 'development') {
      console.warn(`[runtimeConfig] ${configUrl} returned ${response.status}, using .env fallback`)
    }
  } catch (error) {
    console.warn(`[runtimeConfig] Failed to load ${configUrl}, using build-time env fallback.`, error)
  }

  loaded = true
  if (process.env.NODE_ENV === 'development') {
    console.info('[runtimeConfig]', config ? 'loaded from file' : 'using .env fallback', {
      configUrl,
      apiV1: getApiV1Url(),
      apiV2: getApiV2Url(),
      signalR: getSignalRNegotiateUrl()
    })
  }
  return config
}

export function getApiV1Url () {
  return resolveTier(config?.apiV1, process.env.VUE_APP_API_BASE_URL)
}

export function getApiV2Url () {
  return resolveTier(config?.apiV2, process.env.VUE_APP_BLOB_URL)
}

export function getSignalRNegotiateUrl () {
  const base = getApiV2Url()
  if (!base) return ''
  return base.endsWith('/') ? `${base}negotiate` : `${base}/negotiate`
}

/** @internal test helper */
export function __resetRuntimeConfigForTests () {
  config = null
  loaded = false
}

/** @internal test helper */
export function __setRuntimeConfigForTests (value) {
  config = value
  loaded = true
}
